import { handleResponse } from 'api/utils';
import { SettingPasswordUpdatePayload } from 'pages/merchant/dashboard/setting/my-profile/types';
import getFetchOptions from 'utils/getFetchOptions';

export const updateSettingPassword = async (host: string, payload: SettingPasswordUpdatePayload): Promise<void> => {
  const options = await getFetchOptions('POST', { payload });
  return await fetch(`${host}/authn/change-password`, options).then(handleResponse);
};
